import EventEmitter from "./EventEmitter";
class UI extends EventEmitter {
  constructor() {
    super();
    this.uiBar = document.getElementById("bottom_ui");
    this.uiBar.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (e.target.classList.contains("ui")) {
        this.emit("click", [e.target.dataset.action]);
      }
    });

    this.handlers = {
      transitionend: this.onTransitionEnd.bind(this),
    };

    // get the share button
    this.shareButton = document.getElementById("share");
    // get the hint element
    this.hint = document.getElementById("hint");
    // get the zoomin button
    this.zoomInButton = document.getElementById("zoomin");
    //  get the zoomout button
    this.zoomOutButton = document.getElementById("zoomout");
    // get the continue button
    this.continueButton = document.getElementById("continue");
    // get the replay button
    this.replayButton = document.getElementById("replay");
    // get the pause button
    this.pauseButton = document.getElementById("pause");
    // get the play button
    this.playButton = document.getElementById("play");
    // get the back button
    this.backButton = document.getElementById("back");
    // get the forward button
    this.forwardButton = document.getElementById("forward");
    // get the link button
    this.linkButton = document.getElementById("link");
    // get the volumeOff button
    this.volumeButton = document.getElementById("volume");
    // get the skip button
    this.skipButton = document.getElementById("skip");
    // get the keyboardMessage
    this.keyboardMessage = document.getElementById("keyboardMessage");
    // get the about button
    this.aboutButton = document.getElementById("about");

    this.buttons = {
      share: this.shareButton,
      hint: this.hint,
      zoomin: this.zoomInButton,
      zoomout: this.zoomOutButton,
      continue: this.continueButton,
      replay: this.replayButton,
      pause: this.pauseButton,
      play: this.playButton,
      back: this.backButton,
      forward: this.forwardButton,
      link: this.linkButton,
      volume: this.volumeButton,
      skip: this.skipButton,
      keyboardMessage: this.keyboardMessage,
      about: this.aboutButton,
    };

    this.keepHidden = false;
  }

  show(name) {
    if (!this.keepHidden) {
      this.buttons[name].classList.remove("ghost");
      setTimeout(() => {
        this.buttons[name].classList.remove("hidden");
      }, 20);
    }
  }

  hide(name) {
    this.buttons[name].addEventListener(
      "transitionend",
      this.handlers.transitionend
    );
    this.buttons[name].classList.add("hidden");
  }

  set(name, value, option = null) {
    this.buttons[name].textContent = value;
    if (option) {
      this.buttons[name].dataset.tooltip = option;
    }
  }

  hideAll() {
    for (const key in this.buttons) {
      this.hide(key);
    }
  }
  hideAllExcept(exception) {
    for (const key in this.buttons) {
      // if (key != exception) this.hide(key);
      if (typeof exception == "string") {
        if (key != exception) this.hide(key);
      } else {
        if (!exception.includes(key)) this.hide(key);
      }
    }
  }

  onTransitionEnd(e) {
    if (e.target.classList.contains("hidden")) {
      e.target.classList.add("ghost");
    }
    e.target.removeEventListener("transitionend", this.handlers.transitionend);
  }
}

export default new UI();
